// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__iqtqZ","errors":"Errors_errors__1QLM0"};